import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery, transformErrorResponse, transformErrorResponseWithMessage, transformResponse } from "../baseQuery";

export const StudyAbroadStepsApiSlice = createApi({
    reducerPath: "StudyAbroadStepsApiSlice",
    baseQuery,

    tagTypes: ["abroad"],

    endpoints: (builder) => ({
        // Study abroad steps and id based API
        getStudyAbroadStepsApi: builder.query({
            query: (id) => ({
                url: `studyAbroadSteps/user/${id}`,
                method: "GET",
            }),
            transformResponse,
            transformErrorResponse: transformErrorResponseWithMessage,
            providesTags: ["abroad"]
        }),
    }),
});

export const {
    useGetStudyAbroadStepsApiQuery,
} = StudyAbroadStepsApiSlice; 